<div class="flex flex-col justify-center items-center mb-20 px-4 md:px-0 text-center mt-5 md:mt-10">

    <div class="flex justify-center ">
        <fa-icon [icon]="faHeartBroken" class="text-[250px] text-blue-200 items-center"></fa-icon>
    </div>

    <p class="font-medium font-noto-serif text-3xl text-[var(--dark-teal)]">Well… that wasn’t supposed to happen. </p>

    <p class="font-medium text-xl text-[var(--charcoal)]">We’re working to fix the issue. Please try again shortly.</p>

    <button pButton type="button" severity="info" class="w-full md:w-[158px] h-[35px] mt-2" label="Back to Home"
        [routerLink]="['/']">
    </button>

</div>